(() => {
  const productionSections = [
    { id: "custom-shop", className: "production-custom-shop", label: "Maximum freedom" },
    { id: "factory-custom", className: "production-factory-custom", label: "Guided specification" },
    { id: "factory-standard", className: "production-factory-standard", label: "Ready-defined" },
    { id: "perrys-choice", className: "production-perrys-choice", label: "Workshop one-offs" },
  ];

  function initializeProductionPage() {
    const main = document.querySelector(".template-page-australian-production #MainContent");
    if (!main || main.dataset.productionInitialized === "true") return;

    const containers = [...main.querySelectorAll(".ormsby-section-container")];
    if (containers.length < productionSections.length) return;

    main.dataset.productionInitialized = "true";

    productionSections.forEach((config, index) => {
      const container = containers[index];
      const section = container.closest(".shopify-section");
      const heading = container.querySelector(".section-title");

      container.id = config.id;
      container.classList.add("production-tier", config.className);
      container.dataset.tierLabel = config.label;

      if (heading) {
        heading.id = `${config.id}-title`;
        heading.dataset.label = config.label;
        section.setAttribute("aria-labelledby", heading.id);
      }

      container.querySelectorAll(".flex-item").forEach((card) => {
        const image = card.querySelector("img");
        if (image && (!image.alt || /^(image description|full width image)$/i.test(image.alt))) {
          image.alt = `${heading?.textContent.trim() || "Australian production"} Ormsby guitar`;
        }
      });
    });

    const overview = main.querySelector(".production-overview");
    overview?.closest(".shopify-section")?.classList.add("production-overview-section");

    const modelGrid = main.querySelector("ormsby-model-carousel")?.closest(".shopify-section");
    if (modelGrid) {
      modelGrid.classList.add("production-model-tiers");
      const modelContainer = modelGrid.querySelector(".ormsby-models-container");
      if (modelContainer) modelContainer.id = "production-finish-tiers";
    }

    const videoSection = [...main.querySelectorAll(":scope > .shopify-section")].find((section) =>
      section.querySelector(".video-section"),
    );
    videoSection?.classList.add("production-film");

    const collectionSection = main.querySelector(':scope > .shopify-section[id*="featured_collection"]');
    collectionSection?.classList.add("production-available");
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initializeProductionPage);
  } else {
    initializeProductionPage();
  }

  document.addEventListener("shopify:section:load", initializeProductionPage);
})();
